import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import _ from '../../utils/underscore';
import Directive from '../../core/directive';
import * as NavbarConst from './navbar_const';
import {ELEMENTS} from './navbar_const';
import {USER_EVENTS} from '../../events/events';
import GameModeToggleNavbarPart from './parts/game_mode_toggle_navbar_part';
import CloseButtonNavbarPart from './parts/close_button_navbar_part';
import AnalyticsTrigger from './analytics_trigger';
import FullScreenButtonNavbarPart from './parts/full_screen_button_navbar_part';
import GameSessionIdNavbarPart from './parts/game_session_id_navbar_part';
import FreePlayToggleNavbarPart from './parts/free_play_toggle_navbar_part';
import FreePlayIndicatorNavbarPart from './parts/free_play_indicator_navbar_part';
import AgeResponsibleGameComponent from "../regulation_components/base/age/age_responsible_game_component";
import {ANALYTICS} from "./navbar_const";
let navbarHtml = require('./view/navbar.html');

export default class GameNavigationBarComponentController extends BaseComponent {
    static CLASS = 'GameNavigationBarComponentController';

    init(params) {
        super.init(params);
        this._setParameters(params);
        this._buildView();
    }

    _setParameters(params) {
        this._isReal = params.isReal;
        this._gameType = params.gameType;
        this._gameName = params.gameName;
        this._marketing = params.marketing;
        this._showGameModeToggle = this._defaultIfNullOrUndefined(params.showGameModeToggle, false);
        this._showClock = this._defaultIfNullOrUndefined(params.showClock, true);
        this._showCloseButton = this._defaultIfNullOrUndefined(params.showCloseButton, true);
        this._showAge = this._defaultIfNullOrUndefined(params.showAge, true);
        this._showFullScreenButton = this._defaultIfNullOrUndefined(params.showFullScreenButton, true);
        //this._showFavoritesButton = params.showFavoritesButton;
        this._showLogin = this._defaultIfNullOrUndefined(params.showLogin, true);
        this._loginProperties = this._defaultIfNullOrUndefined(params.loginProperties, this._getDefaultLoginProps());
        this._cashierOpenType = this._defaultIfNullOrUndefined(params.cashierOpenType, this.serviceFactory.gameManagerService().cashierOpenType());
        this._freePlayData = params.freePlayData;
        this._responsibleGamblingView = params.responsibleGamblingView;
        this._referrerId = params.referrerId;
        this._showGameSessionId = this._defaultIfNullOrUndefined(params.showGameSessionId, true);
        this._showFreePlaySelection = true;
        if (_.isBoolean(params.showFreePlaySelection)) {
            this._showFreePlaySelection = params.showFreePlaySelection;
        }

        this._analyticsTrigger = AnalyticsTrigger.create({
            isReal: this._isReal,
            gameType: this._gameType,
            gameName: this._gameName
        })
    }

    _getDefaultLoginProps() {
        let navBarProps = this.serviceFactory.gameManagerService().getNavbarProps();
        if(navBarProps) {
            return navBarProps.login;
        }

        return null;
    }

    _defaultIfNullOrUndefined(value, defaultValue) {
        if(_.isNullOrUndefined(value)) {
            return defaultValue;
        }
        return value;
    }

    _buildView() {
        DOM.html(this.bake(navbarHtml), this.getEl());
        this._setTitle();
        this._createClock();
        this._createAge();
        this._createSessionTimer();
        this._createGameModeToggle();
        this._createFullScreenButton();
        this._createCloseButton();
        this._createGameSessionId();
        this._createWelcome();
        this._createFreePlayIndicator();
        this._createResponsibleIcons();

    }

    _createFreePlayIndicator() {
        if (!this._showFreePlaySelection) {
            // don't add FreePlayIndicatorNavbarPart
            return;
        }

        let freePlayIndicator = FreePlayIndicatorNavbarPart.create({
            freePlayData: this._freePlayData,
            gameType: this._gameType,
            referrerId: this._referrerId
        });
        this.appendChildComponent(freePlayIndicator, '.cgp-navbar-fp-indicator-container');
    }

    _createRegulationParts() {

    }

    _onCloseCallbacks = [];
    registerOnCloseCallback(onCloseCallback) {
        this._onCloseCallbacks.push(onCloseCallback);
    }

    _createSessionTimer() {
        if (!this.serviceFactory.regulationService().sessionTimerVisible()) {
            return;
        }

        let sessionTimer = Directive.generate({directiveName: 'session_timer', start: true, props: {}});
		this.appendChildComponent(sessionTimer, NavbarConst.ELEMENTS.SESSION_TIMER);
    }


    _createResponsibleIcons() {
        if (!this.serviceFactory.regulationService().getRegulation().showResponsibleIcons()) {
            return;
        }

        let responsibleIcons = Directive.generate({directiveName: 'responsible_gaming_icons', start: true, props: {}});
        DOM.addClass(responsibleIcons.getEl(), 'cgp-theme-property-background-color-dark-grey');
        this.appendChildComponent(responsibleIcons, NavbarConst.ELEMENTS.RESPONSIBLE_GAME_ICONS);
    }

    _createGameSessionId() {
        if(!this._showGameSessionId) {
            this._gameSessionId = {
                setGameSessionId: () => {}
            };
            return;
        }

        this._gameSessionId = GameSessionIdNavbarPart.create({
            analyticsTrigger: this._analyticsTrigger
        });
        this.appendChildComponent(this._gameSessionId, NavbarConst.ELEMENTS.SESSION);
        this.querySelector(NavbarConst.ELEMENTS.SESSION).style.display = 'block';
    }

    _createWelcome() {
        if (!this._showLogin) {
            return;
        }

        let gameOptions = {
            isReal: this._isReal,
            gametype: this._gameType,
            gameName: this._gameName
        };

        let props = Object.assign({}, gameOptions, {
            layout: 'game-panel',
            silentMode: true,
            cashierOpenType: this._cashierOpenType,
            env: 'game'
        }, this._loginProperties);

        let welcome = Directive.generate(
            {
                directiveName: 'welcome',
                props,
                start: true
            });

        this.appendChildComponent(welcome, NavbarConst.ELEMENTS.LOGIN);
        welcome.start();
    }


    _createGameModeToggle() {
        let isFreePlay = !_.isNullOrUndefined(this._freePlayData);
        if(!this._showGameModeToggle && !isFreePlay) {
            this.addClass(ELEMENTS.NO_TOGGLE);
            return;
        }


        let gameModeToggle = null;
        if(isFreePlay){
            gameModeToggle = FreePlayToggleNavbarPart.create({
                freePlayData: this._freePlayData
            })
        } else {
            gameModeToggle = GameModeToggleNavbarPart.create({
                isReal: this._isReal,
                isFreePlay: isFreePlay,
                switchGameModeCallback: this._switchGameMode.bind(this),
                analyticsTrigger: this._analyticsTrigger
            });
        }



        this.appendChildComponent(gameModeToggle, '.cgp-navbar-toggle-container');

    }

    _switchGameMode() {
        if(this._isReal) {
            return this.serviceFactory.gameService().openAnonymousGame({
                gameType: this._gameType,
                gameName: this._gameName,
                marketing: this._marketing,
                inGameModeSwitching: true,
                referrerId: this._referrerId // ??
            });
        } else {
            return this.serviceFactory.gameService().openRealGame({
                gameType: this._gameType,
                gameName: this._gameName,
                marketing: this._marketing,
                inGameModeSwitching: true,
                referrerId: this._referrerId // ??
            });
        }
    }


    _createCloseButton() {
        if(!this._showCloseButton) {
            return;
        }

        let closeButton = CloseButtonNavbarPart.create({
            onCloseCallback: this._onClose.bind(this)
        });

        this.appendChildComponent(closeButton, NavbarConst.ELEMENTS.CLOSE);
    }

    _createFullScreenButton() {
        if(!this._showFullScreenButton) {
            this._fullScreenButton = {
                exitFullScreen: () => {}
            };
            return;
        }

        this._fullScreenButton = FullScreenButtonNavbarPart.create({
            analyticsTrigger: this._analyticsTrigger
        });

        this.appendChildComponent(this._fullScreenButton, NavbarConst.ELEMENTS.FS);
    }

    _createAge() {
        if (!this._showAge) {
            return;
        }
        let age = AgeResponsibleGameComponent.create({
            analytics: this._analyticsTrigger.getAnalyticsObject(ANALYTICS.ACTION.RG),
            responsibleGamblingView: this._responsibleGamblingView
        });
        age.start();

        this.appendChildComponent(age, '.cgp-navbar-age-container');
    }


    _createClock() {
        if(!this._showClock) {
            return;
        }

        let clock = Directive.generate({directiveName: 'clock', start: true, props: {datetime: this.serviceFactory.skinService().getTimeFormat()}});

        this.appendChildComponent(clock, NavbarConst.ELEMENTS.CLOCK);
        this.onChildElementEvent(NavbarConst.ELEMENTS.CLOCK, USER_EVENTS.ON_CLICK, () => {
            this._analyticsTrigger.send(NavbarConst.ANALYTICS.ACTION.TIME);
        });
    }

    _setTitle() {
        let navbarElement = this.querySelector(NavbarConst.ELEMENTS.NAME);

        DOM.text(navbarElement, this._gameName);
        this.onChildElementEvent(NavbarConst.ELEMENTS.NAME, USER_EVENTS.ON_CLICK, () => {
            this._analyticsTrigger.send(NavbarConst.ANALYTICS.ACTION.GAME_NAME);
        });

    }

    _onClose() {
        this._analyticsTrigger.send(NavbarConst.ANALYTICS.ACTION.CLOSE);
        this._fullScreenButton.exitFullScreen();
        this._onCloseCallbacks.forEach(onCloseCallback => {
            onCloseCallback();
        });
    }

    setGameSessionId(sessionId) {
        this._gameSessionId.setGameSessionId(sessionId);
    }
}